// src/pages/TeamPage.tsx
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import {
  ArrowLeft,
  Percent,
  Calendar as CalendarIcon,
  Share2,
  Headset,
  BarChart2,
  BookOpen,
} from 'lucide-react'
import { Button } from '../components/ui/Button'
import { Card, CardContent } from '../components/ui/Card'
import { Footer } from '../components/landing/Footer'

export default function TeamPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="container mx-auto max-w-3xl mb-12 flex-grow">
        <div className="mb-8">
          <Button
            as={Link}
            to="/"
            variant="ghost"
            className="flex items-center"
          >
            <ArrowLeft size={18} className="mr-1" />
            Back to Home
          </Button>
        </div>

        <Card>
          <CardContent className="px-6 md:px-8 py-12">

            {/* Hero */}
            <h1 className="text-4xl md:text-5xl font-display font-bold mb-4 text-gray-950 text-center">
              Become a Team <span className="gradient-text">Member</span>
            </h1>
            <p className="text-lg text-gray-700 mb-12 max-w-3xl mx-auto text-center">
              Do you like and actually use our journal? Nice! You can now recommend it to your
              community and earn up to{' '}
              <strong className="text-primary-700">40% commission</strong>, paid monthly!
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  icon: <Percent size={32} className="text-primary-600" />,
                  title: '40% Recurring Commission',
                  text: 'Earn up to 40% of every subscription fee for the life of your referrals.',
                },
                {
                  icon: <CalendarIcon size={32} className="text-primary-600" />,
                  title: 'Paid Monthly or Yearly',
                  text: 'Receive payments on each renewal—monthly or yearly.',
                },
                {
                  icon: <Share2 size={32} className="text-primary-600" />,
                  title: 'Easy to Share',
                  text: 'Get your unique link & code and start earning in seconds.',
                },
                {
                  icon: <Headset size={32} className="text-primary-600" />,
                  title: 'Dedicated Support',
                  text: 'Access our partner resources and expert help.',
                },
                {
                  icon: <BarChart2 size={32} className="text-primary-600" />,
                  title: 'Performance Reports',
                  text: 'Track clicks, sign-ups, and earnings in real time.',
                },
                {
                  icon: <BookOpen size={32} className="text-primary-600" />,
                  title: 'Partner Resources',
                  text: 'Get marketing assets, guides, and best practices.',
                },
              ].map(({ icon, title, text }) => (
                <div
                  key={title}
                  className="bg-white/30 p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center hover:-translate-y-2 border border-gray-200/50 hover:border-primary-200"
                >
                  <div className="bg-primary-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6 border border-primary-100">
                    {icon}
                  </div>
                  <h3 className="font-semibold text-lg mb-3 text-gray-900">{title}</h3>
                  <p className="text-gray-700">{text}</p>
                </div>
              ))}
            </div>

            {/* Call to Action */}
            <div className="text-center mt-16">
              <Button
                as="a"
                href="mailto:simplifiedtradingjournal@pm.me"
                className="bg-black hover:bg-gray-900 text-white font-medium px-10 py-4 text-lg !rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                Apply &amp; Start Earning Now!
              </Button>
              <p className="mt-4 text-gray-700">simplifiedtradingjournal@pm.me</p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  )
}
